<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-summary-salary-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
        <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{'blur-zero' : scope.row.approvedVocherQty === 0}">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="帳務日期" width="100" fixed>
            <template slot-scope="scope">
                <div>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" class-name="strong" min-width="200" fixed>
            <template slot-scope="scope">
                <div>{{ getSummaryText(scope.row) }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="salaryTotal" label="固定/非固定月薪資總額" class-name="blue strong" min-width="170" align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.salaryTotal" />
            </template>
        </el-table-column>
        <el-table-column prop="salaryTotal" label="績效、獎金" min-width="130" class-name="strong" align="right">
            <template slot-scope="scope">
                <Money :v="scope.row.salaryBonus" />
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="代扣稅額" align="right" class-name="strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingTax" />
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="代扣健保" align="right" class-name="strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingTax_Health" />
            </template>
        </el-table-column>
        <el-table-column prop="taX_AMT" label="代扣勞保" align="right" class-name="strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingTax_Labor" />
            </template>
        </el-table-column>
        <el-table-column prop="geN2_AMT" label="代扣二代健保" align="right" class-name="strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingTax_Health2" />
            </template>
        </el-table-column>
        <el-table-column prop="withholdingTax_FEE_ELS" label="其他代扣" align="right" class-name="strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.withholdingTax_FEE_ELS" />
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="實付薪資" align="right" class-name="strong" width="150">
            <template slot-scope="scope">
                <Money
                    :v="
                        scope.row.salaryTotal +
                            scope.row.salaryBonus -
                            scope.row.withholdingTax -
                            scope.row.withholdingTax_Health -
                            scope.row.withholdingTax_Labor -
                            scope.row.withholdingTax_Health2 -
                            scope.row.withholdingTax_FEE_ELS
                    "
                />
            </template>
        </el-table-column>
        <el-table-column prop="cny" label="幣別" min-width="70" align="center">TWD</el-table-column>
        <el-table-column label="建立日期" width="120">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onRowClick(data) {
            this.$emit('openDetail', { year: data.year, month: data.month }, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
        getSummaryText(row) {
            const TIME = moment(`${row.year}/${row.month}/01`).format('YYYY-MM');

            return `${TIME} 薪資支出`;
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-salary-table {
    .el-table__body-wrapper {
        height: 550px;
    }
    .blue {
        background-color: #f1f4ff;
    }
    .el-table__row {
        cursor: pointer;
    }
}
</style>
